import { graphql } from 'gql'

export const UPDATE_RICH_PLACEMENT_K_WORDS = graphql(`
  mutation updateRichPlacementKWords(
    $input: UpdateWorkspaceRichPlacementKwordsConfigurationInput!
  ) {
    updateWorkspaceRichPlacementKwordsConfiguration(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
